
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevInputText } from '@ds/components/InputText'
import { RevLink } from '@ds/components/Link'
import { RevList } from '@ds/components/List'
import { RevListItem } from '@ds/components/ListItem'
import { RevModal } from '@ds/components/Modal'
import { IconSearch } from '@ds/icons/IconSearch'
import { IconWarning } from '@ds/icons/IconWarning'
import isEmpty from 'lodash/isEmpty'

import { MODAL_NAMES } from '@config/constants'
import { searchObjects } from '@core/helpers/SearchObjects'

import translations from './TechSpecModal.translations'

export default {
  components: {
    RevInputText,
    RevLink,
    RevModal,
    RevList,
    RevListItem,
    RevInfoBlock,
  },
  props: {
    technicalSpecifications: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    valueFilter: '',
  }),
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.TECH_SPECS,
    translations: () => translations,
    iconWarning: () => IconWarning,
    IconSearch: () => IconSearch,

    showReassurancesBlocks() {
      return !isEmpty(this.technicalSpecifications.reassurances)
    },
    reassurances() {
      return this.technicalSpecifications.reassurances
    },
    showSpecifications() {
      return !isEmpty(this.technicalSpecifications.specifications)
    },
    specifications() {
      return searchObjects(
        this.technicalSpecifications.specifications,
        'display',
        this.valueFilter,
      )
    },
    showAdditionalInfo() {
      return !isEmpty(this.technicalSpecifications.additionalInfo)
    },
    additionalInfo() {
      return this.technicalSpecifications.additionalInfo
    },
    showWarnings() {
      return !isEmpty(this.technicalSpecifications.warnings)
    },
    warnings() {
      return this.technicalSpecifications.warnings
    },
  },
}
